import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ValidatorFn, AsyncValidatorFn, FormBuilder, AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import DataSource from 'devextreme/data/data_source';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OperazioniDisponibili, Soggetto, FirRemoto, OutputEventCampiInit, OutputEventCampiStatus, OutputEventCampiErrors, OutputEventCampiValue } from '../../interfaces';
import { alert } from 'devextreme/ui/dialog';
import { Apiservice } from '../../../../services/api.service';
import CustomStore from 'devextreme/data/custom_store';
import { FormsTemplateService } from '../../../../services/forms-template.service';
import { DocumentTask, FirDigitaliTransactionService, TransactionStateMap } from '../../../../services/fir-digitali-transaction.service';

@Component({
  selector: 'app-dati-accettazione',
  templateUrl: './dati-accettazione.component.html',
  styleUrls: ['./dati-accettazione.component.css']
})
export class DatiAccettazioneComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() operazioniDisponibili: OperazioniDisponibili
  @Input() soggetto: Soggetto
  @Input() group: Array<"Accettazione">;
  @Input() firRemoto: FirRemoto
  @Input() sezioneGroup: string
  @Input() meta: { [key: string]: boolean } = {}
  @Output() initGroup = new EventEmitter<OutputEventCampiInit>();
  @Output() statusChange = new EventEmitter<OutputEventCampiStatus>();
  @Output() errorsChange = new EventEmitter<OutputEventCampiErrors>();
  @Output() valueChange = new EventEmitter<OutputEventCampiValue>();
  protected formGroups: FormGroup = this.fb.group({})
  // protected isDisabled: boolean = false
  protected currentGroup: string = ''
  protected fields: Record<string, {
    label: string;
    validators?: ValidatorFn[];
    asyncValidators?: AsyncValidatorFn[];
    disabled?: boolean;
    items?: {
      dataSource?: DataSource | any[];
      displayExpr?: string | ((item: any) => string);
      valueExpr?: string | ((item: any) => string);
    }
  }>
  private destroy$ = new Subject<void>();

  constructor(
    private readonly fb: FormBuilder,
    private readonly Apiservice: Apiservice,
    private readonly FormsTemplateService: FormsTemplateService,
    private readonly FirTransaction: FirDigitaliTransactionService) { }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  ngAfterViewInit(): void {
    console.log(this)
    this.initGroup.emit({
      name: 'onInit',
      value: this.formGroups.value,
      formGroups: this.formGroups,
      sezione: this.sezioneGroup,
      component: this,
      touched: this.isFormTouched()
    })
  }

  ngOnInit() {
    if (!this.meta || !this.group || !this.soggetto || !this.operazioniDisponibili || !this.firRemoto) alert('Errore', 'Attenzione');
    else {
      this.currentGroup = 'Accettazione';
      this.processFieldsMetadata();
      this.processFormGroup()

      this.formGroups.statusChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => this.emitEvents());

      this.formGroups.valueChanges
        .pipe(takeUntil(this.destroy$))
        .subscribe(value => {
          this.valueChange.emit({ name: 'valueChange', formGroups: this.formGroups, value: value, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
          this.emitEvents();
        });
      // this.FirTransaction.globalQueue$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: DocumentTask[]) => {
      //     this.isDisabled = next.length > 0 ? next.some((task) => (task.status !== 'error' && task.status !== 'completed') ?
      //       this.group.includes(task.processId as any) : false) : false
      //   },
      // })
      // this.FirTransaction.state$.pipe(takeUntil(this.destroy$)).subscribe({
      //   next: (next: TransactionStateMap) => {
      //     this.isDisabled = next[this.firRemoto.dati_partenza.numero_fir] ?
      //       (next[this.firRemoto.dati_partenza.numero_fir].status !== 'error' && next[this.firRemoto.dati_partenza.numero_fir].status !== 'completed') ?
      //         next[this.firRemoto.dati_partenza.numero_fir].listTask.some((val) => (val.status !== 'completed' && val.status !== 'error') ? this.group.includes(val.processId as any) : false)
      //         : false : false
      //   },
      // })
    }
  }

  hasError(actionKey: string, fieldKey: string): boolean {
    const group = this.getForm(actionKey);
    if (!group) return false;
    const control = group.get(fieldKey);
    if (!control) return false;
    if (!control.touched) return false;
    return control.invalid;
  }
  getForm(key: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    return this.formGroups.get(key) as FormGroup;
  }
  getValue(key: string, field: string): FormGroup | null {
    if (!this.formGroups.get(key)) return null
    const group = this.formGroups.get(key) as FormGroup;
    const campo = group.get(field)
    if (!campo) return null
    return campo.value;
  }

  onDxChange(group, field, event) {
    console.log(event)
    console.log(field)
    console.log(group)
    const gruppo = this.formGroups.get(group)
    if (!gruppo) return
    const control = gruppo.get(field)
    if (!control) return
    control.setValue(event.value)
    gruppo.updateValueAndValidity()

    if (field === 'tipo_accettazione') {
      this.onAccettazioneChange(event.value);
    }
  }
  //! -------------------------------------------------------------------------
  private onAccettazioneChange(value: any): void {
    if (value !== 'A') {
      this.fields['causale_respingimento'].disabled = false
      this.fields['motivo_respingimento'].disabled = false
    } else {
      this.fields['causale_respingimento'].disabled = true
      this.fields['motivo_respingimento'].disabled = true
    }
    const group = this.getForm('Accettazione');
    group.get('causale_respingimento').setValue(null);
    group.get('motivo_respingimento').setValue('');
  }
  private emitEvents(): void {
    const messages = []
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;

      const value = group.getRawValue();
      for (const field of Object.keys(value)) {
        const msg = this.getErrorMessage(actionKey, field);
        if (msg) messages.push(msg);
      }
    }
    const status = this.formGroups.status === 'VALID' ? 'VALID' : 'INVALID';
    this.statusChange.emit({ name: 'statusChange', status, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
    this.errorsChange.emit({ name: 'errorsChange', errors: messages, formGroups: this.formGroups, sezione: this.sezioneGroup, component: this, touched: this.isFormTouched() });
  }
  private isFormTouched(): boolean {
    for (const actionKey of this.group) {
      if (this.meta[actionKey] === false) continue;
      const group = this.getForm(actionKey);
      if (!group) continue;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      if (hasValue) return true
    }
    return false;
  }

  private getErrorMessage(actionKey: string, field: string): string | null {
    const group = this.getForm(actionKey);
    const control = group.get(field);
    if (!control || !control.errors) return null;
    const errors = control.errors;
    const fallbackMessages: Record<string, (err: any) => string> = {
      required: () => `Campo ${this.fields[field].label} obbligatorio`,
      minlength: err => `Campo ${this.fields[field].label} minimo ${err.requiredLength} caratteri`,
      maxlength: err => `Campo ${this.fields[field].label} massimo ${err.requiredLength} caratteri`,
      min: err => `Campo ${this.fields[field].label} valore minimo ${err.min}`,
      max: err => `Campo ${this.fields[field].label} valore massimo ${err.max}`,
      pattern: () => `Campo ${this.fields[field].label} non valido`,
      custom: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
      async: err => typeof err === 'string' ? err : `${this.fields[field].label} non valido`,
    };
    for (const key of Object.keys(errors)) {
      const err = errors[key];
      if (fallbackMessages[key]) return fallbackMessages[key](err);
    }
    return `Campo non valido`;
  }

  private dynamicGroupActivation(
    validatorsMap: Record<string, ValidatorFn[]>
  ): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      if (!(group instanceof FormGroup)) return null;
      const controls = Object.entries(group.controls);
      const values = controls.map(([_, ctrl]) => (ctrl.value || '').toString().trim());
      const hasValue = values.some(v => v !== '');
      for (const [field, ctrl] of controls) {
        const originalValidators = validatorsMap[field] || [];
        if (hasValue) {
          ctrl.setValidators(originalValidators);
        } else {
          ctrl.clearValidators();
        }
        ctrl.updateValueAndValidity({ emitEvent: false, onlySelf: true });
      }
      return null;
    };
  }

  private processFormGroup() {
    for (const key of this.group) {
      const subGroup = this.fb.group({});
      this.formGroups.addControl(key, subGroup);
      this.buildForm(subGroup, key);
    }
  }

  private buildForm(subGroup: FormGroup, operazione: string) {
    const data = {
      tipo_accettazione: null,
      quantita_accettata: null,
      causale_respingimento: null,
      motivo_respingimento: '',
      data_ora_arrivo: null,
      attesa_verifica_analitica: false,
    }
    // if (this.firRemoto.dati_accettazione&&this.firRemoto.dati_destinazioni_successive===null) {
    //   data.tipo_accettazione = this.firRemoto.dati_accettazione.tipo_accettazione
    //   data.quantita_accettata = this.firRemoto.dati_accettazione.quantita_accettata.valore
    //   data.causale_respingimento = this.firRemoto.dati_accettazione.causale_respingimento
    //   data.motivo_respingimento = this.firRemoto.dati_accettazione.motivo_respingimento
    //   data.data_ora_arrivo = this.firRemoto.dati_accettazione.data_ora_arrivo
    //   data.attesa_verifica_analitica = this.firRemoto.dati_accettazione.attesa_verifica_analitica
    // }
    subGroup.addControl('tipo_accettazione', this.fb.control(data.tipo_accettazione));
    subGroup.addControl('quantita_accettata', this.fb.control(data.quantita_accettata));
    subGroup.addControl('causale_respingimento', this.fb.control(data.causale_respingimento));
    subGroup.addControl('motivo_respingimento', this.fb.control(data.motivo_respingimento));
    subGroup.addControl('data_ora_arrivo', this.fb.control(data.data_ora_arrivo));
    subGroup.addControl('attesa_verifica_analitica', this.fb.control(data.attesa_verifica_analitica));
    const validatorsMap: Record<string, ValidatorFn[]> = {};
    for (const fieldName of Object.keys(subGroup.controls)) {
      validatorsMap[fieldName] = this.fields[fieldName].validators || [];
    }
    if (this.meta[operazione] === false) return;
    else return subGroup.setValidators(this.dynamicGroupActivation(validatorsMap));
  }
  private processFieldsMetadata() {
    this.fields = {
      tipo_accettazione: {
        label: 'Accettazione',
        validators: [Validators.required],
        items: {
          dataSource: this.FormsTemplateService.getDati('accettazioneTipo'),
          displayExpr: 'descrizione',
          valueExpr: 'id'
        }
      },
      quantita_accettata: {
        label: 'Quantità',
        validators: [Validators.required],
      },
      causale_respingimento: {
        label: 'Causale Respingimento',
        validators: [this.customValidator((value: any, form: AbstractControl) => {
          const fieldRespinto = form.get('tipo_accettazione')
          return fieldRespinto.value !== 'A' && !value ? false : true
        })],
        disabled: true,
        items: {
          dataSource: [
            { id: 'NC', descrizione: 'PARZIALE' },
            { id: 'IR', descrizione: 'TOTALE' },
            { id: 'A', descrizione: 'ALTRO' },
          ],
          displayExpr: 'descrizione',
          valueExpr: 'id',
        }
      },
      motivo_respingimento: {
        label: 'Motivazione Respingimento',
        disabled: true,
        validators: [this.customValidator((value: any, form: AbstractControl) => {
          const fieldRespinto = form.get('tipo_accettazione')
          return fieldRespinto.value !== 'A' && !value ? false : true
        })],
      },
      data_ora_arrivo: {
        label: 'Data e Ora',
        validators: [Validators.required],
      },
      attesa_verifica_analitica: {
        label: 'Attesa Verifica',
        validators: [],
      },
    }
  }
  private customValidator(fn: (value: any, form?: AbstractControl) => boolean | string): ValidatorFn {
    return (control: AbstractControl) => {
      const result = fn(control.value, control.parent);
      if (result === true) return null;
      if (result === false) return { custom: true };
      if (typeof result === 'string') return { custom: result };
      return null;
    };
  }

}
